import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import ConditionScoreSlider from './../../components/ConditionScoreSlider/ConditionScoreSlider';
import * as actionTypes from './../../store/actions/conditionScoreAction';
import fetchConditionScoreAction from './../../store/actions/fetch/fetchConditionScoreAction';
import Loader from './../../components/Loader/Loader'

/**
 * Condition Score container
 */
class ConditionScore extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  render() {
    const {data, error, pending, selected, onSelect, defaultValues, ready, casuistic, selectedCriticalCare} = this.props;
    // If there is a need for default data
    if(!ready && !error && !pending) {
      defaultValues();
    }
    // If data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Return switcher
    return (
      <div className='nppe2-fc-condition-score-slider__wrapper'>
        {error && <span className='nppe2-fc-condition-score-slider__error'>{error}</span>}
        {!error &&
          <ConditionScoreSlider
            data={data}
            selected={selected}
            onSelect={onSelect}
            casuistic={casuistic}
            selectedCriticalCare={selectedCriticalCare}
            casuistic={casuistic}
          />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.conditionScoreReducer.selected,
    error: state.conditionScoreReducer.error,
    data: state.conditionScoreReducer.data,
    pending: state.conditionScoreReducer.pending,
    ready: state.conditionScoreReducer.ready,
    casuistic: state.calculateDerReducer.data.casuistic,
    selectedCriticalCare: state.criticalCareReducer.selected,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchConditionScoreAction
      },
      dispatch,
    ),
    onSelect: (id) => dispatch({
      type: actionTypes.SELECT,
      selected: id,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ConditionScore);
